

import React, { useState, useRef, useEffect } from 'react';
import { Box, Button, Typography, TextField, IconButton } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
// import CustomInput from '../CustomInput/CustomInput';
import CustomInputLogin from '../../Components/CustomInputLogin/CustomInputLogin';
import CustomInputLoginComponent from '../../Components/CustomInputLogin/CustomInputLoginComponent';
import MicrosoftLogin from './MicrosoftLogin';


const EmployeeSignInForm = ({ handleSubmit, toggleForgotPassword, handleGoRegistrationPage }) => {
  
const validationSchema = Yup.object({
    employeeid: Yup.string()
        .required('Employee ID is required'),
    password: Yup.string()
        .required('Password is required'),
});

    return (
        <Formik
            initialValues={{
                employeeid: '', password: ''
                // , captcha: ''
            }}
            validationSchema={validationSchema}
            onSubmit={(values, { setFieldError }) => {
                // if (values.captcha.toUpperCase() !== captchaText) {
                //     setFieldError("captcha", "CAPTCHA is incorrect. Try again.");
                //     refreshCaptcha();
                // } else {
                //     handleSubmit(values);

                // }
                handleSubmit(values);

            }}
        >
            {({ errors, touched, handleChange }) => (
                <Form style={{ width: '100%' }}>
                    <Box mb={2}>
                        <CustomInputLoginComponent name="employeeid" label="Employee Id" custPlaceholder="Enter Employee Id" inputType="number" />
                    </Box>

                    <Box mb={2}>
                        <CustomInputLoginComponent name="password" label="Password" custPlaceholder="Enter Password" inputType="password" />
                    </Box>

                    {/* CAPTCHA Section */}
                    <Box display="flex" flexDirection="column" alignItems="center" mb={1}>
                        {/* <Box display="flex" flexDirection="row" alignItems="center" mb={1} mt={1}>

                            <canvas ref={canvasRef} style={{ width: "100%", maxWidth: "400px", borderRadius: 8 }} ></canvas>
                            <IconButton onClick={refreshCaptcha} sx={{ mt: 1 }}>
                                <RefreshIcon />
                            </IconButton>
                        </Box> */}
                        {/* <Box
                            display="flex"
                            flexDirection="row"
                            alignItems="center"
                            justifyContent="flex-start"
                            mb={2}
                            mt={2}
                            p={1}
                            sx={{
                                // backgroundColor: 'white', // matches the page background
                                // border: '1px solid #e0e0e0', // subtle border for light theme
                                // borderRadius: 2,
                                // boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.05)', // optional subtle shadow
                                // maxWidth: '420px',
                            }}
                        >
                            <canvas
                                ref={canvasRef}
                                style={{
                                    width: '100%',
                                    maxWidth: '350px',
                                    height: '60px',
                                    // borderRadius: 8,
                                    // backgroundColor: '#fafafa', // very light gray to hint it's interactive
                                    backgroundColor: 'red', // very light gray to hint it's interactive
                                   
                                    border: '1px solid #e0e0e0',
                                }}
                            ></canvas>

                            <IconButton
                                onClick={refreshCaptcha}
                                sx={{
                                    ml: 1,
                                    backgroundColor: '#f9f9f9',
                                    border: '1px solid #e0e0e0',
                                    '&:hover': {
                                        backgroundColor: '#f0f0f0',
                                    },
                                }}
                            >
                                <RefreshIcon fontSize="small" />
                            </IconButton>
                        </Box> */}

                        {/* <CustomInputLogin
                            name="captcha"
                            label="Captcha"
                            custPlaceholder="Enter CAPTCHA"
                            // inputType="password"
                            onChange={handleChange}

                        /> */}

                        {/* <TextField
                            name="captcha"
                            label="Enter CAPTCHA"
                            fullWidth
                            margin="normal"
                            error={touched.captcha && Boolean(errors.captcha)}
                            helperText={touched.captcha && errors.captcha}
                            onChange={handleChange} */}
                        {/* /> */}
                    </Box>
                    <Box
                        display="flex"
                        justifyContent="end"
                        alignItems="end"
                        width="100%"
                        mb={3}
                        color="#C38F51"
                    >
                        <Typography variant='body1' fontSize="16px">
                            <Typography
                                variant='subtitle1'
                                onClick={toggleForgotPassword}
                                underline="none"
                                sx={{ cursor: "pointer" }}
                                color='var(--main-color)'
                            >
                                Forgot password?
                            </Typography>
                        </Typography>
                    </Box>

                    <Button
                        fullWidth
                        type="submit"
                        variant="contained"
                        sx={{
                            // borderRadius: 23,
                            textTransform:"none",
                            py: "7px",
                            color: "white",
                            backgroundColor: "var(--main-color)"
                        }}
                    >
                        Log In
                    </Button>
                    {/* <MicrosoftLogin /> */}
                    

                    {/* <Typography variant="body1" mt={2} sx={{ fontSize: "16px", textAlign: 'center' }}>
                        Don't have an account?&nbsp;
                        <Box sx={{ color: "var(--main-color)", cursor: "pointer" }} onClick={handleGoRegistrationPage}>
                            Register here
                        </Box>
                    </Typography> */}
                </Form>
            )
            }
        </Formik >
    );
};

export default EmployeeSignInForm;
